<script>
export default {
  name: "InputField",
  props: {
    modelValue: String,
    type: { type: String, default: "text" },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    placeholder: { type: String, default: "Enter text..." },
    rows: { type: Number, default: 3 },
    isTextarea: { type: Boolean, default: false },
    label: { type: String, default: "" },
    maxlength: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue"],
};
</script>

<template>
    <div class="w-100">
        <label v-if="label" :for="modelValue">{{ label }}</label>
        <input v-if="!isTextarea" class="styled-input" :type="type" :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)" :disabled="disabled" :readonly="readonly"
            :placeholder="placeholder" :maxlength="maxlength" />
        <textarea v-else class="styled-input" :rows="rows" :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)" :disabled="disabled" :readonly="readonly"
            :placeholder="placeholder" :maxlength="maxlength" />
    </div>
</template>

<style scoped lang="scss">
label {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 5px;
}

/* ------------------------------
   STYLED INPUTS (underline style)
------------------------------ */
.styled-input,
.styled-select {
  width: 100%;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #ddd;
  background: transparent;
}

.styled-input:focus,
.styled-select:focus {
  outline: none;
  border-color: transparent;
  border-bottom: 1px solid #428bca;
  box-shadow: none;
}

.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
</style>